class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.parser = new DOMParser();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(e) {
    this.updateOptions(e.target.value);
    this.updateMasterId(e.target.value);
    this.updateVariantDetails();
    this.updateSizeOptionsVisibility();

    try{
      this.fetchProductDetails(this.getSelectedVariantURL());
    }
    catch(error){
      
    }
    document.querySelector('#sunnies-flask') || document.querySelector('#pebble-flask') || document.querySelector('#sunnies-flask-test') || document.querySelector('#robo-flask') || document.querySelector('#bubble-lite-flask') || document.querySelector('#bubble-flask') ? '' : (this.redirectURL(), this.disableButton());
  }

  disableButton(){
    try{
      document.querySelector('.product-details .Product__header form button').setAttribute('disabled','');
    }catch(error){

    }
  }

  async fetchProductDetails(url) {
    const fullUrl = url /*+ '&section_id=' + section*/;
    
    fetch(fullUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.statusText}`);
        }
        return response.text(); // assuming the response is in text format
      })
      .then((data) => {
        // const sectionElement = document.querySelector(`#shopify-section-${section} form`);

        this.updateProductDetails(data);
        this.updateGallery(data);
        // updatePrescription(data);
        // Update the link after the fetch operation completes
        const customizeFlaskKidsBtnLink = document.querySelector('#customizeFlaskKidsBtnLink');

        const selectedInput = document.querySelector('.input-label-wrapper input:checked');
        if(selectedInput && selectedInput.dataset.redirection && selectedInput.dataset.redirection.length > 1){
          customizeFlaskKidsBtnLink ? customizeFlaskKidsBtnLink.href = `/products/robo-flask?source=sunnies-flask&${selectedInput.dataset.redirection}` : '';
        }else{
          customizeFlaskKidsBtnLink ? customizeFlaskKidsBtnLink.href = `/products/pebble-flask?source=sunnies-flask&bottle=${this.getCurrentVariantColor()}` : '';
        }
        
      })
      .catch((error) => {
        console.error('Fetch error:', error);
      });
  }

  updateGallery(data){
    const productGallery = document.querySelectorAll('.product-gallery-swipper');
    const doc = parser.parseFromString(data, 'text/html');
    const newProductGallery = doc.querySelectorAll('.product-gallery-swipper');
    productGallery.forEach((element, index) => {
      element.replaceWith(newProductGallery[index]);
    })
  
    document.querySelector('#product-gallery-container').setAttribute('data-product-sku', doc.querySelector('#product-gallery-container').getAttribute('data-product-sku'));
    loadGallerySwiper();
    initializeVTOGallerySwiper()
  }

  updateProductDetails(data){
      const doc = parser.parseFromString(data, 'text/html');
      if(!document.querySelector('#sunnies-flask') && !document.querySelector('#pebble-flask') && !document.querySelector('#sunnies-flask-test') && !document.querySelector('#robo-flask') && !document.querySelector('#bubble-lite-flask') && !document.querySelector('#bubble-flask')){
        const productDetailsHeader = document.querySelector('.product-details .Product__header form');
        const newProductDetailsHeader = doc.querySelector('.product-details .Product__header form');
        productDetailsHeader.replaceWith(newProductDetailsHeader);
      }
      else{
        const variantRadios = document.querySelector('variant-radios fieldset.swatch');
        const newvariantRadios = doc.querySelector('variant-radios fieldset.swatch');
        variantRadios.replaceWith(newvariantRadios);
      }

    const productPrice = document.querySelector('#product-price');
    const newproductPrice = doc.querySelector('#product-price');
    productPrice.replaceWith(newproductPrice);

    try {
      const optionName = document.querySelector('#option_name');
      const optionColor = document.querySelector('#option_color');
      optionName.innerText = document.querySelector('body').id.includes('flask') || document.querySelector('body').id.includes('boot') || document.querySelector('body').id.includes('bottle') || document.querySelector('body').id.includes('pebble-cap') || document.querySelector('body').id.includes('loop') ? this.getCurrentVariantSize() : this.getCurrentVariantSize() + ' | ';
      optionColor.innerText = document.querySelector('body').id.includes('flask') || document.querySelector('body').id.includes('boot') || document.querySelector('body').id.includes('bottle') || document.querySelector('body').id.includes('pebble-cap') || document.querySelector('body').id.includes('loop') ? ': ' + this.getCurrentVariantColor() ? ': ' + this.getCurrentVariantColor() : this.fallbackOption : this.getCurrentVariantColor();





    } catch (error) {
      console.error(error);
    }
    
    const productImage = document.querySelector('.desktop-product-vto-container');
    const newProductImage= doc.querySelector('.desktop-product-vto-container');
    productImage.replaceWith(newProductImage);
    
    if(document.querySelector('#sunnies-flask') || document.querySelector('#pebble-flask') || document.querySelector('#sunnies-flask-test') || document.querySelector('#robo-flask') || document.querySelector('#bubble-lite-flask') || document.querySelector('#bubble-flask')){
      document.querySelector('variant-radios fieldset.swatch input[checked]').click()
    }
    document.querySelector('body').id.includes('flask') || document.querySelector('body').id.includes('bottle') || document.querySelector('body').id.includes('pebble-cap') || document.querySelector('body').id.includes('loop') ? '' : this.sizeGuide();
  }

  sizeGuide() {
    try {
      const modal = document.getElementById("sizeGuideModal") || "";
      const triggerBtn = document.querySelector(".size-guide-modal-trigger") || "";
      const closeBtn = document.querySelector(".size-guide-modal__close") || "";

      triggerBtn.onclick = function () {
        modal.style.display = "block";
      }

      closeBtn.onclick = function () {
        modal.style.display = "none";
      }
      window.onclick = function (event) {
        if (event.target == modal) {
          modal.style.display = "none";
        }
      }
    } catch (error) {

    }


    const modal1 = $("#sizeGuideModalDynamic") || "";

    $(document).on('click', '.size-guide-modal-trigger--dynamic', function (e) {
      e.preventDefault();
      modal1.show();
    });

    $(document).on('click', '.size-guide-modal__close--dynamic', function () {
      modal1.hide();
    });

    $(document).on('click', function (event) {
      if (event.target.id == modal1.attr('id')) {
        modal1.hide();
      }
    })

  }

  getSelectedVariantURL(){
    const url = `${this.dataset.url}?variant=${ this.currentVariant ? this.currentVariant.id : this.fallbackOption.id}`;
    return url;
  }
  
  updateOptions(selectedVariantType) {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const checkedRadio = Array.from(fieldset.querySelectorAll('input')).find((radio) => { 
        return radio.checked
      });
      return checkedRadio ? checkedRadio.value : null;
    });

  }

  updateMasterId(selectedVariantType) {
    // Try to find exact variant match - check if all selected options exist in variant options
    // (order-independent comparison since fieldset order may differ from variant.options order)
    const variant = this.getVariantData().find(variant => {
      const variantOpts = variant.options;
      return this.options.every(opt => opt && variantOpts.includes(opt)) && 
             variantOpts.every(opt => this.options.includes(opt));
    }); 
    
    this.fallbackOption = this.getVariantData().find((variant) => {
      if (variant.available) {
        return variant.options.some((option) => option === this.options[1] || option === this.options[0]);
      }
    }) || this.getVariantData().find((variant) => {
      return variant.options.some((option) => option === this.options[1] || option === this.options[0]);
    });
       
    if (!variant) {
      if(document.querySelector('#sunnies-flask') || document.querySelector('#pebble-flask') || document.querySelector('#sunnies-flask-test') || document.querySelector('#robo-flask') || document.querySelector('#bubble-lite-flask') || document.querySelector('#bubble-flask')){
        // For flask products: if current color doesn't exist for new size, default to first available color for that size
        const allVariants = this.getVariantData();
        const previousVariant = this.currentVariant || this.fallbackOption;
        const previousColor = previousVariant ? previousVariant.option1 : null;
        const previousSize = previousVariant ? previousVariant.option2 : null;
        
        // Find the new size - it's the option that changed (option2 is size)
        // Check which option in this.options corresponds to a size (option2)
        let newSize = null;
        for (const optionValue of this.options) {
          // Check if this option value exists as option2 (size) in any variant
          const sizeVariant = allVariants.find(v => v.option2 === optionValue);
          if (sizeVariant) {
            newSize = optionValue;
            break;
          }
        }
        
        // If we couldn't find new size, try to detect which option changed
        if (!newSize && previousSize) {
          // Find which option is different from previous size
          for (const optionValue of this.options) {
            if (optionValue !== previousSize) {
              const testVariant = allVariants.find(v => v.option2 === optionValue);
              if (testVariant) {
                newSize = optionValue;
                break;
              }
            }
          }
        }
        
        // Fallback: use first option if we still can't determine
        if (!newSize && this.options.length > 0) {
          newSize = this.options[0];
        }
        
        // First, try to find a variant with the new size and previous color (if it exists)
        let fallbackVariant = null;
        if (previousColor && newSize) {
          fallbackVariant = allVariants.find(v => 
            v.option2 === newSize && v.option1 === previousColor && v.available
          );
        }
        
        // If not found, find first available variant with the new size
        if (!fallbackVariant && newSize) {
          fallbackVariant = allVariants.find(v => 
            v.option2 === newSize && v.available
          );
        }
        
        // If still not found, find any variant with the new size (even if unavailable)
        if (!fallbackVariant && newSize) {
          fallbackVariant = allVariants.find(v => 
            v.option2 === newSize
          );
        }
        
        // If still not found, use the original fallbackOption or first available variant
        this.currentVariant = fallbackVariant || this.fallbackOption || allVariants.find(v => v.available) || allVariants[0];
        
        // Update the radio button to match the new variant
        if (this.currentVariant) {
          // Find the color fieldset (option1 is color)
          const colorFieldset = Array.from(this.querySelectorAll('fieldset')).find(fieldset => {
            const radios = Array.from(fieldset.querySelectorAll('input'));
            return radios.some(radio => radio.value === this.currentVariant.option1);
          });
          
          if (colorFieldset) {
            const matchingRadio = Array.from(colorFieldset.querySelectorAll('input')).find(radio => 
              radio.value === this.currentVariant.option1
            );
            if (matchingRadio && !matchingRadio.checked) {
              matchingRadio.checked = true;
              // Update options to reflect the new selection
              this.updateOptions(matchingRadio.value);
            }
          }
        }
      }else{
        // First, try to find a variant that matches BOTH selected options
        const exactMatch = this.getVariantData().find(variant => {
          const variantOpts = variant.options;
          return this.options.every(opt => opt && variantOpts.includes(opt)) && 
                 variantOpts.every(opt => this.options.includes(opt));
        });
        
        if (exactMatch) {
          this.currentVariant = exactMatch;
        } else {
          // Fallback: find variants containing the selected variant type
          const variants = this.getVariantData().filter(variant => 
            variant.options.some(option => option === selectedVariantType)
          );

          // Try to find one that also has the other selected option
          const newVariant = variants.find(variant => 
            variant.options.some(option => option === this.options[1]) && 
            variant.options.some(option => option === this.options[0])
          ) || variants.find(variant => 
            variant.options.some(option => option === this.options[1] || option === this.options[0])
          );

          this.currentVariant = newVariant || variants[0];
        }
      }
    } else {
      this.currentVariant = variant;
      this.updateCustomizeFlaskKidsBtnLink();

    }
  }

  decodeHTMLEntities(text) {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = text;
    return textarea.value;
  }

  updateVariantDetails() {
    
    if (!this.currentVariant) {
      console.warn('No current variant found. Please select a variant.');
      // Optionally, you can update the UI to inform the user
      const productVariantDetails = document.querySelector('#customProductDetails');
      if (productVariantDetails) {
        productVariantDetails.innerHTML = 'Please select a variant to see details.';
      }
      return; // Exit the function early
    }

    const productVariantDetails = document.querySelector('#customProductDetails');
    const productVariantData = document.querySelector("#variant_metafields_descriptions");

    if (productVariantData == null) {
      console.log('No product variant data found');
      return; // Exit the function early
    }

    try {
      const productVariantJsonData = JSON.parse(productVariantData.textContent || '{}');
      
      // Ensure currentVariant has a valid id
      if (!this.currentVariant.id) {
        console.warn('Current variant has no id, attempting to find fallback');
        // Try to find a valid variant
        const allVariants = this.getVariantData();
        this.currentVariant = this.fallbackOption || allVariants.find(v => v.available) || allVariants[0];
        
        if (!this.currentVariant || !this.currentVariant.id) {
          console.error('Could not find a valid variant');
          if (productVariantDetails) {
            productVariantDetails.innerHTML = '';
          }
          return;
        }
      }
      
      const productVariantId = this.currentVariant.id.toString();
      const productVariantDescVal = productVariantJsonData[productVariantId];

      if (productVariantDescVal) {
        productVariantDetails.innerHTML = this.decodeHTMLEntities(productVariantDescVal);
      } else {
        productVariantDetails.innerHTML = '';
      }
    } catch (error) {
      console.error('Failed to parse product variant data:', error);
      // Clear the details on error to prevent showing stale data
      const productVariantDetails = document.querySelector('#customProductDetails');
      if (productVariantDetails) {
        productVariantDetails.innerHTML = '';
      }
    }
  }

  /**
   * Hides size options that have no variant for the currently selected color (e.g. size 13 only for Black).
   * When the selected size becomes hidden, selects the first visible size and syncs variant state.
   */
  updateSizeOptionsVisibility() {
    const sizeFieldset = this.querySelector('.product-option-size-fieldset');
    const colorFieldset = this.querySelector('fieldset.swatch');
    if (!sizeFieldset || !colorFieldset) return;
    let variants;
    try {
      variants = this.getVariantData();
    } catch (e) {
      return;
    }
    if (!Array.isArray(variants) || variants.length === 0) return;
    const colorInput = colorFieldset.querySelector('input:checked');
    const selectedColor = colorInput ? colorInput.value : null;
    if (selectedColor == null) return;
    const sizeWrappers = sizeFieldset.querySelectorAll('.product-option-size');
    let firstVisibleWrapper = null;
    sizeWrappers.forEach((wrapper) => {
      const sizeValue = wrapper.getAttribute('data-option-value');
      const hasVariant = variants.some((v) => v.option1 === selectedColor && v.option2 === sizeValue);
      if (hasVariant) {
        wrapper.style.display = '';
        if (firstVisibleWrapper == null) firstVisibleWrapper = wrapper;
      } else {
        wrapper.style.display = 'none';
      }
    });
    const checkedInput = sizeFieldset.querySelector('input:checked');
    const checkedWrapper = checkedInput ? checkedInput.closest('.product-option-size') : null;
    const checkedSizeHidden = checkedWrapper && checkedWrapper.style.display === 'none';
    if (checkedSizeHidden && firstVisibleWrapper) {
      const newSizeInput = firstVisibleWrapper.querySelector('input');
      if (newSizeInput) {
        newSizeInput.checked = true;
        this.updateOptions(newSizeInput.value);
        this.updateMasterId(newSizeInput.value);
        const form = this.closest('form');
        if (form) {
          const variantIdInput = form.querySelector('.js-variant-id');
          if (variantIdInput && this.currentVariant) variantIdInput.value = this.currentVariant.id;
        }
        const optionNameEl = document.querySelector('#option_name');
        if (optionNameEl && this.currentVariant) optionNameEl.innerText = this.getCurrentVariantSize() + ' | ';
        this.updateVariantDetails();
      }
    }
  }

  connectedCallback() {
    this.updateSizeOptionsVisibility();
    // Call updateCustomizeFlaskKidsBtnLink when the element is added to the DOM
    const selectedVariant = this.currentVariant || this.fallbackOption || this.getVariantData().find(variant => variant.available) || this.getVariantData().at(0);
    const customizeFlaskKidsBtnLink = document.querySelector('#customizeFlaskKidsBtnLink');
    const selectedInput = document.querySelector('.input-label-wrapper input:checked');
    if(selectedInput && selectedInput.dataset.redirection && selectedInput.dataset.redirection.length > 1){
      customizeFlaskKidsBtnLink ? customizeFlaskKidsBtnLink.href = `/products/robo-flask?source=sunnies-flask&${selectedInput.dataset.redirection}` : '';
    }else{
    customizeFlaskKidsBtnLink ? customizeFlaskKidsBtnLink.href = `/products/robo-flask?source=sunnies-flask&size=16oz&bottle=${selectedVariant.option1}` : '';
    }
  }

  updateCustomizeFlaskKidsBtnLink(){
    const customizeFlaskKidsBtnLink = document.querySelector('#customizeFlaskKidsBtnLink');
    const selectedInput = document.querySelector('.input-label-wrapper input:checked');
    if(selectedInput && selectedInput.dataset.redirection && selectedInput.dataset.redirection.length > 1){
      customizeFlaskKidsBtnLink ? customizeFlaskKidsBtnLink.href = `/products/robo-flask?source=sunnies-flask&${selectedInput.dataset.redirection}` : '';
    }else{
    customizeFlaskKidsBtnLink ? customizeFlaskKidsBtnLink.href = `/products/robo-flask?source=sunnies-flask&size=16oz&bottle=${this.getCurrentVariantColor()}` : ''; 
    }
  }

  redirectURL() {
    if (!this.currentVariant && !this.fallbackOption) return;
    // window.location.href = `${this.dataset.url}?variant=${ this.currentVariant ? this.currentVariant.id : this.fallbackOption.id}`;
    history.pushState({}, '', `${this.dataset.url}?variant=${ this.currentVariant ? this.currentVariant.id : this.fallbackOption.id}`);
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getCurrentVariantID(){
    return this.currentVariant.id
  }

  getCurrentVariantSize(){
    return (this.currentVariant && this.currentVariant.option2) || this.fallbackOption.option2;
  }

  getCurrentVariantColor(){
      return this.currentVariant?.option1
  }


}

customElements.define('variant-radios', VariantRadios);
